import { LOCALES } from './constants';

/**
 * @param {Record<string, unknown>} obj
 * @param {string} path dot-separated
 * @returns {unknown}
 */
export function getByPath(obj, path) {
  const parts = path.split('.');
  let cur = obj;
  for (const p of parts) {
    if (cur == null || typeof cur !== 'object') return undefined;
    cur = cur[p];
  }
  return cur;
}

/**
 * @param {string} template
 * @param {Record<string, string | number>} [vars]
 */
export function interpolate(template, vars) {
  if (!vars || typeof template !== 'string') return template;
  return Object.keys(vars).reduce(
    (acc, k) => acc.replaceAll(`{${k}}`, String(vars[k])),
    template
  );
}

/** 首次造訪：navigator.language → ja | zh-TW */
export function getDefaultLocaleFromNavigator() {
  const raw = (typeof navigator !== 'undefined' && navigator.language) || '';
  const lang = raw.toLowerCase();

  if (lang.startsWith('ja')) return 'ja';
  if (
    lang === 'zh-tw' ||
    lang === 'zh-hk' ||
    lang === 'zh-mo' ||
    lang.startsWith('zh-tw') ||
    lang.startsWith('zh-hk')
  ) {
    return 'zh-TW';
  }
  if (lang === 'zh-cn' || lang === 'zh-sg' || lang.startsWith('zh-cn') || lang.startsWith('zh-sg')) {
    return 'zh-TW';
  }
  if (lang.startsWith('zh')) return 'zh-TW';

  return 'ja';
}

/** @param {string | null} stored */
export function normalizeStoredLocale(stored) {
  if (stored && LOCALES.includes(stored)) return stored;
  return null;
}
